var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('v-btn',{attrs:{"icon":"","small":"","title":"Feedback"},on:{"click":_vm.openFeedback}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icons.mdiCommentTextOutline)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }